import { EmptyCell } from '@casops/components/tables/formatters/genericFormatters';
import { useListConfigurationGroupsQuery } from '@casops/store/apis/configurationGroupsApi';

export const useGetConfigurationGroupName = (configGroupId?: number | null): string => {
  const { data: configGroups } = useListConfigurationGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  if (configGroupId == null || !configGroups) return EmptyCell;
  return configGroups.find(group => group.id === configGroupId)?.name ?? EmptyCell;
};
